import { Moment } from 'moment';

export class EventCustomerSummary {
	customerId: number;
	role: EventCustomerRole;
	name: string;
	phone: string;
	email: string;
}

export class EventCustomer {
	eventCustomerId: number;
	customerId: number;
	role: EventCustomerRole;
	name: string;
	jobTitle: string;
	canEmail: boolean;
	email: string;
	canSMS: boolean;
	phone: string;

	isMe: boolean;
	notifyOnRsvp: boolean;
	attendeeStatus?: EventAttendeeStatus;
	attendeeDetails?: {
		[key: string]: string;
	};
	feedback?: EventFeedback;
}

export class EventFeedback {
	score?: number;
	comment: string;
}

export interface NewEventCustomer {
	customerId?: number;
	role: EventCustomerRole;
	name: string;
	jobTitle?: string;
	email: string;
	phone: string;
	dateOfBirth?: string | Moment;
	attendeeStatus?: EventAttendeeStatus;
	attendeeDetails?: {
			[key: string]: string;
	};
}

export interface UpdatedEventCustomer {
	role: EventCustomerRole;
	name?: string;
	email?: string;
	phone?: string;
	attendeeStatus?: EventAttendeeStatus;
	attendeeDetails?: {
			[key: string]: string;
	};
}

export enum EventCustomerRole {
	Organiser = 1,
	Company = 2,
	Attendee = 3,
	Child = 4
}

export enum EventAttendeeStatus {
	Invited = 0,
	Attending = 1,
	NotAttending = 2
}

export class NewEventFeedback {
	score?: number;
	comment: string;
}
